<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :filter="filter"
        module="basic"
        url="warehouseLocations"
        :columns-property="columnsProperty"
        :table-select="false"
        @reset="resetHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="仓库名称">
              <el-input v-model.trim="filter.warehouseName" placeholder="请输入仓库名称" clearable/>
            </el-form-item>
            <el-form-item label="库区名称">
              <el-input v-model.trim="filter.warehouseAreaName" placeholder="请输入库区名称" clearable/>
            </el-form-item>
            <el-form-item label="仓位名称">
              <el-input v-model.trim="filter.warehouseLocationName" placeholder="请输入仓位名称" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
    <warehouse-location-edit ref="warehouseLocationEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import WarehouseLocationEdit from "./WarehouseLocationEdit.vue";
  import ViewTable from "@/components/ViewTable";

  export default {
    name: "WarehouseLocationList",
    components: {
      ViewTable,
      WarehouseLocationEdit,
    },
    data() {
      return {
        limits: {
          addAuth: this.$auth(952),
          editAuth: this.$auth(954),
          delAuth: this.$auth(955),
        },

        filter: {
          warehouseName: "",
          warehouseAreaName: "",
          warehouseLocationName: "",
        },

        columnsProperty: [
          {
            key: "warehouseName",
            tooltip: true,
          },
          {
            key: "warehouseAreaName",
            tooltip: true,
          },
          {
            key: "warehouseLocationName",
            tooltip: true,
          },
          {
            key: "warehouseLocationNo",
            width: 120,
            align: "center",
          },
          {
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            key: "createTime",
            width: 160,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
          },
        ],
      };
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.warehouseLocationEdit.open(1, row);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "warehouseLocations", row.pkId).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
    },
  };
</script>

<style lang="scss">
.ivu-table td,
.ivu-table th {
  height: 37px;
  font-size: 13px;
  .el-button--mini {
    padding: 7px 10px;
  }
}
</style>
